module.exports = __webpack_public_path__ + "img/ic-sensibilisation.9c8ac744.svg";